@if (pageInfo.pageBar) {
  <header
    class="admin-page-bar"
    [class.admin-page-bar--subpage]="showBack()"
    aria-label="Encabezado de página"
  >
    <div class="admin-page-bar__main">
      @if (showBack()) {
        <button
          type="button"
          class="admin-page-bar__back"
          (click)="goBack()"
          [attr.aria-label]="backAriaLabel()"
        >
          <i-tabler name="chevron-left" class="admin-page-bar__back-icon flex" aria-hidden="true"></i-tabler>
        </button>
      }

      <div class="admin-page-bar__titles">
        @if (moduleEyebrowText(); as moduleLabel) {
          <p class="admin-page-bar__eyebrow">{{ moduleLabel }}</p>
        }
        <div class="admin-page-bar__title-row">
          <h1 class="admin-page-bar__title">{{ titleText() }}</h1>
          @if (leadingExtra(); as leadingTpl) {
            @if (leadingExtraPlacement() === 'titleInline') {
              <div class="admin-page-bar__leading-extra admin-page-bar__leading-extra--title-inline">
                <ng-container *ngTemplateOutlet="leadingTpl" />
              </div>
            }
          }
        </div>

        @if (subtitleText(); as subtitle) {
          <p class="admin-page-bar__subtitle">{{ subtitle }}</p>
        }
      </div>

      @if (showEndCluster()) {
        <div class="admin-page-bar__end">
          @if (leadingExtra(); as leadingTpl) {
            @if (leadingExtraPlacement() !== 'titleInline') {
              <div class="admin-page-bar__leading-extra">
                <ng-container *ngTemplateOutlet="leadingTpl" />
              </div>
            }
          }

          @if (visibleActions().length) {
            <div class="admin-page-bar__actions admin-page-bar__actions--desktop">
              @for (action of desktopBarActions(); track action.id) {
                @if (visibleMenuItems(action); as splitItems) {
                  @if (splitItems.length) {
                    <button
                      type="button"
                      [class]="actionButtonClass(action)"
                      [disabled]="action.disabled"
                      [matMenuTriggerFor]="actionSplitMenu"
                    >
                      @if (action.icon) {
                        @if (isIconifyActionIcon(action.icon)) {
                          <span class="iconify admin-page-bar__action-icon" [attr.data-icon]="action.icon" aria-hidden="true"></span>
                        } @else {
                          <mat-icon>{{ action.icon }}</mat-icon>
                        }
                      }
                      {{ actionLabel(action) }}
                      <mat-icon class="admin-page-bar__split-chevron">arrow_drop_down</mat-icon>
                    </button>
                    <mat-menu
                      #actionSplitMenu="matMenu"
                      xPosition="before"
                      class="admin-page-bar-actions-menu"
                      panelClass="admin-page-bar-actions-menu"
                    >
                      @for (item of splitItems; track item.id) {
                        <button
                          type="button"
                          mat-menu-item
                          [disabled]="item.disabled"
                          (click)="runAction(item)"
                        >
                          <span class="admin-page-bar-actions-menu__row">
                            @if (item.icon) {
                              @if (isIconifyActionIcon(item.icon)) {
                                <span
                                  class="iconify admin-page-bar-actions-menu__icon"
                                  [attr.data-icon]="item.icon"
                                  aria-hidden="true"
                                ></span>
                              } @else {
                                <span
                                  class="material-icons admin-page-bar-actions-menu__icon"
                                  aria-hidden="true"
                                  >{{ item.icon }}</span
                                >
                              }
                            }
                            <span class="admin-page-bar-actions-menu__label">{{
                              actionLabel(item)
                            }}</span>
                          </span>
                        </button>
                      }
                    </mat-menu>
                  } @else {
                    <button
                      type="button"
                      [class]="actionButtonClass(action)"
                      [disabled]="action.disabled"
                      (click)="runAction(action)"
                    >
                      @if (action.icon) {
                        @if (isIconifyActionIcon(action.icon)) {
                          <span class="iconify admin-page-bar__action-icon" [attr.data-icon]="action.icon" aria-hidden="true"></span>
                        } @else {
                          <mat-icon>{{ action.icon }}</mat-icon>
                        }
                      }
                      {{ actionLabel(action) }}
                    </button>
                  }
                }
              }
              @if (desktopMenuActions().length) {
                <button
                  type="button"
                  class="milinco-btn-icon"
                  [matMenuTriggerFor]="pageBarDesktopMenu"
                  [attr.aria-label]="'catalog.myPage.actions' | translate"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu
                  #pageBarDesktopMenu="matMenu"
                  xPosition="before"
                  class="admin-page-bar-actions-menu"
                  panelClass="admin-page-bar-actions-menu"
                >
                  @for (action of desktopMenuActions(); track action.id) {
                    <button
                      type="button"
                      mat-menu-item
                      [disabled]="action.disabled"
                      (click)="runAction(action)"
                    >
                      <span class="admin-page-bar-actions-menu__row">
                        @if (action.icon) {
                          @if (isIconifyActionIcon(action.icon)) {
                            <span
                              class="iconify admin-page-bar-actions-menu__icon"
                              [attr.data-icon]="action.icon"
                              aria-hidden="true"
                            ></span>
                          } @else {
                            <span
                              class="material-icons admin-page-bar-actions-menu__icon"
                              aria-hidden="true"
                              >{{ action.icon }}</span
                            >
                          }
                        }
                        <span class="admin-page-bar-actions-menu__label">{{
                          actionLabel(action)
                        }}</span>
                      </span>
                    </button>
                  }
                </mat-menu>
              }
            </div>

            <div class="admin-page-bar__actions admin-page-bar__actions--mobile">
              @for (action of mobileInlineActions(); track action.id) {
                @if (visibleMenuItems(action); as splitItems) {
                  @if (splitItems.length) {
                    <button
                      type="button"
                      [class]="actionButtonClass(action)"
                      [disabled]="action.disabled"
                      [attr.aria-label]="actionLabel(action)"
                      [matMenuTriggerFor]="mobileInlineSplitMenu"
                    >
                      @if (action.icon) {
                        @if (isIconifyActionIcon(action.icon)) {
                          <span class="iconify admin-page-bar__action-icon" [attr.data-icon]="action.icon" aria-hidden="true"></span>
                        } @else {
                          <mat-icon>{{ action.icon }}</mat-icon>
                        }
                      }
                      {{ mobileActionLabel(action) }}
                      <mat-icon class="admin-page-bar__split-chevron">arrow_drop_down</mat-icon>
                    </button>
                    <mat-menu
                      #mobileInlineSplitMenu="matMenu"
                      xPosition="before"
                      class="admin-page-bar-actions-menu"
                      panelClass="admin-page-bar-actions-menu"
                    >
                      @for (item of splitItems; track item.id) {
                        <button
                          type="button"
                          mat-menu-item
                          [disabled]="item.disabled"
                          (click)="runAction(item)"
                        >
                          <span class="admin-page-bar-actions-menu__row">
                            @if (item.icon) {
                              @if (isIconifyActionIcon(item.icon)) {
                                <span
                                  class="iconify admin-page-bar-actions-menu__icon"
                                  [attr.data-icon]="item.icon"
                                  aria-hidden="true"
                                ></span>
                              } @else {
                                <span
                                  class="material-icons admin-page-bar-actions-menu__icon"
                                  aria-hidden="true"
                                  >{{ item.icon }}</span
                                >
                              }
                            }
                            <span class="admin-page-bar-actions-menu__label">{{
                              actionLabel(item)
                            }}</span>
                          </span>
                        </button>
                      }
                    </mat-menu>
                  } @else {
                    <button
                      type="button"
                      [class]="actionButtonClass(action)"
                      [disabled]="action.disabled"
                      [attr.aria-label]="actionLabel(action)"
                      (click)="runAction(action)"
                    >
                      @if (action.icon) {
                        @if (isIconifyActionIcon(action.icon)) {
                          <span class="iconify admin-page-bar__action-icon" [attr.data-icon]="action.icon" aria-hidden="true"></span>
                        } @else {
                          <mat-icon>{{ action.icon }}</mat-icon>
                        }
                      }
                      {{ mobileActionLabel(action) }}
                    </button>
                  }
                }
              }
              @if (mobileMenuActions().length) {
                <button
                  type="button"
                  class="milinco-btn-icon"
                  [matMenuTriggerFor]="pageBarActionsMenu"
                  [attr.aria-label]="'catalog.myPage.actions' | translate"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu
                  #pageBarActionsMenu="matMenu"
                  xPosition="before"
                  class="admin-page-bar-actions-menu"
                  panelClass="admin-page-bar-actions-menu"
                >
                  @for (action of mobileMenuActions(); track action.id) {
                    <button
                      type="button"
                      mat-menu-item
                      [disabled]="action.disabled"
                      (click)="runAction(action)"
                    >
                      <span class="admin-page-bar-actions-menu__row">
                        @if (action.icon) {
                          @if (isIconifyActionIcon(action.icon)) {
                            <span
                              class="iconify admin-page-bar-actions-menu__icon"
                              [attr.data-icon]="action.icon"
                              aria-hidden="true"
                            ></span>
                          } @else {
                            <span
                              class="material-icons admin-page-bar-actions-menu__icon"
                              aria-hidden="true"
                              >{{ action.icon }}</span
                            >
                          }
                        }
                        <span class="admin-page-bar-actions-menu__label">{{
                          actionLabel(action)
                        }}</span>
                      </span>
                    </button>
                  }
                </mat-menu>
              }
            </div>
          }
        </div>
      }
    </div>
  </header>
}
